export default __webpack_public_path__ + "static/media/Shipping.c5c8fe0f.jpg";